import { useMutation } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { OtpToEmail } from "../api/authAPI";
import Spinner from "../components/UI/Spinner";
import TextField from "../components/UI/TextField";
import { useAuthStore } from "../store/authStore";

import bg from "../assets/signInBg.png";
import LoginHeader from "../components/UI/LoginHeader";
import { ToastContainer, toast } from "react-toastify";

const ForgetPassword = () => {
    const {
        register,
        handleSubmit,
        getValues,
    } = useForm();
    const { isLoading, isSuccess, mutate, data, error } = useMutation({
        mutationFn: OtpToEmail,
    });

    const submitlogin = () => {
        const payload = getValues();
        mutate(payload);
    };
    const navigate = useNavigate();
    useEffect(() => {
        if (isSuccess && data) {
            if (data.data.success) {
                const payload = getValues();
                navigate("/verifyotp", { state: payload })
            } else {
                toast("error", data.data.message)
            }
        }
    }, [isSuccess]);

    useEffect(() => {
        toast.error(error?.response?.data?.message)
    }, [error])
    return (
        <div className="login-wrap w-screen h-screen flex items-center justify-center bg-slate-100">
            <ToastContainer />
            <img className="absolute w-full h-full" src={bg} alt="bg" />
            <div className="login-card w-3/12 z-10 shadow-md p-8 bg-white rounded-xl">
                <LoginHeader />
                <br />
                <h1 className="text-3xl font-light">Forget Password</h1>
                <br />

                <form onSubmit={handleSubmit(submitlogin)} className="form">
                    <TextField
                        label="email"
                        placeholder={"Enter your email"}
                        inputProps={{ ...register("email", { required: true }) }}
                    />
                    <Link
                        to="/signup"
                        className="text-tblu hover:underline cursor-pointer w-full"
                    >
                        New to UTM? Sign up here
                    </Link>
                    <br />
                    <br />
                    <button
                        onClick={handleSubmit(submitlogin)}
                        className="text-xl bg-tblu text-white grid items-center w-full p-4 rounded-xl"
                    >
                        {isLoading ? <Spinner /> : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgetPassword;
